import React from 'react';
import NavigationRoutes from 'router/routes/navigation';

export const PublicPage = () => {
  return <NavigationRoutes />;
};

export default PublicPage;
